module.exports = __webpack_public_path__ + "static/media/ALERTA_CTM.ecdb24ec.svg";